import React from 'react';
import { Link } from 'react-router-dom';
import './ProductProgress.css';
import {
  PROJECT_TRACKS,
  PRODUCT_PROGRESS_SECTIONS,
  RECENTLY_DELIVERED,
  getProductProgressMetrics,
} from '../data/productProgressData';

function statusClass(status) {
  return status.toLowerCase();
}

export default function ProductProgress() {
  const metrics = getProductProgressMetrics();

  return (
    <div className="App-body pp-root">
      <div className="pp-hero">
        <div>
          <div className="pp-eyebrow">Visible execution view</div>
          <h1 className="pp-title">Product Progress</h1>
          <p className="pp-subtitle">
            This page makes the roadmap practical: what is already live, what is next,
            and which strategic gaps still need attention. The goal is simple: no more
            hidden planning.
          </p>
          <div className="pp-actions">
            <Link to="/roadmap" className="btn btn-primary">Open commercial roadmap</Link>
            <Link to="/pricing" className="btn btn-outline-secondary">Open pricing and packaging</Link>
          </div>
        </div>

        <div className="pp-stats">
          <div className="pp-stat">
            <div className="pp-stat-value" style={{ color: '#6366f1' }}>{metrics.projects}</div>
            <div className="pp-stat-label">Project tracks</div>
          </div>
          <div className="pp-stat">
            <div className="pp-stat-value" style={{ color: '#10b981' }}>{metrics.live}</div>
            <div className="pp-stat-label">Live capabilities</div>
          </div>
          <div className="pp-stat">
            <div className="pp-stat-value" style={{ color: '#d97706' }}>{metrics.mvp}</div>
            <div className="pp-stat-label">Live as MVP / partial</div>
          </div>
          <div className="pp-stat">
            <div className="pp-stat-value" style={{ color: '#2563eb' }}>{metrics.next}</div>
            <div className="pp-stat-label">Queued next items</div>
          </div>
          <div className="pp-stat">
            <div className="pp-stat-value" style={{ color: '#64748b' }}>{metrics.later}</div>
            <div className="pp-stat-label">Strategic gaps later</div>
          </div>
        </div>
      </div>

      <div className="pp-card pp-recent">
        <div className="pp-section-header">
          <div>
            <div className="pp-section-title">Project tracks</div>
            <div className="pp-section-subtitle">Progress across the related projects around DepGuard</div>
          </div>
          <span className="pp-pill info">Portfolio view</span>
        </div>

        <div className="pp-projects">
          {PROJECT_TRACKS.map((project) => (
            <div key={project.id} className="pp-card pp-project-card">
              <div className="pp-item-head">
                <div className="pp-project-name">{project.name}</div>
                <span className={`pp-status ${statusClass(project.status)}`}>{project.status}</span>
              </div>
              <p className="pp-project-summary">{project.summary}</p>
              <ul className="pp-bullets">
                {project.highlights.map((highlight) => (
                  <li key={highlight}>{highlight}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="pp-grid">
        {PRODUCT_PROGRESS_SECTIONS.map((section) => (
          <div key={section.id} className="pp-card pp-section">
            <div className="pp-section-header">
              <div>
                <div className="pp-section-title">{section.label}</div>
                <div className="pp-section-subtitle">{section.items.length} items</div>
              </div>
              <span className={`pp-pill ${section.tone}`}>{section.label}</span>
            </div>

            <div className="pp-items">
              {section.items.map((item) => (
                <div key={item.title} className="pp-item">
                  <div className="pp-item-head">
                    <div>
                      <div className="pp-item-title">{item.title}</div>
                      {item.todoId && <div className="pp-item-meta">{item.todoId}</div>}
                    </div>
                    <span className={`pp-status ${statusClass(item.status)}`}>{item.status}</span>
                  </div>
                  <p className="pp-item-detail">{item.detail}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="pp-card pp-recent">
        <div className="pp-section-header">
          <div>
            <div className="pp-section-title">Recently delivered</div>
            <div className="pp-section-subtitle">{metrics.recent} visible milestones that landed recently</div>
          </div>
          <span className="pp-pill success">Shipped</span>
        </div>

        <div className="pp-recent-grid">
          {RECENTLY_DELIVERED.map((item) => (
            <div key={item.title} className="pp-recent-item">
              <div className="pp-recent-title">{item.title}</div>
              <p className="pp-recent-detail">{item.detail}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
